import Style from './ContactPage.module.css';

const ContactPage = () => {
    return (
        <div className={Style.ContactPageBackground}>
            {/* Content here */}
            <div className={Style.ContactPage}>
                <h1 className={Style.Email}>CAFERINOGRAAL@HOTMAIL.COM</h1>
            </div>
        </div>
    );
};

export default ContactPage;